module.exports = __webpack_public_path__ + "static/scale-model-of-curemed-assist--medical-tourism-company-in-denton-texas-9b3686c1aab90e9de0a99f66237bd19f.png";